<template>
  <ul v-if="activeBlog" :class="$style.container">
    <li
      v-for="item in renderList" :key="item.name"
      :class="[$style.item, { [$style.itemDisabled]: item.disabled }]"
      @click="item.handler"
    >
      <BaseIcon :name="item.icon" :custom="item.customIcon" :class="$style.icon" />
      <div>{{ item.name }}</div>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'blog-menu',
  data () {
    return {
      list: [
        {
          name: this.$t('createPostBtn'),
          icon: 'comment-medical',
          handler: () => {
            this.$router.push({
              name: 'app-blogs',
              params: {
                blogId: this.activeBlog.shortId
              },
              query: {
                isCreatePost: true
              }
            })
          },
          displayCondition: () => {
            return this.activeBlog.isOwn
          }
        },
        {
          name: this.$t('blogEditTitle'),
          icon: 'pencil-alt',
          handler: () => {
            this.$modal.show('edit-blog', {
              blog: this.activeBlog
            })
          },
          displayCondition: () => {
            return this.activeBlog.isOwn
          }
        },
        {
          name: this.$t('shareBtn'),
          icon: 'share',
          customIcon: true,
          handler: () => {
            const link = window.location.origin + this.$route.path
            this.$modal.show('share-to-chat', {
              value: link,
              text: `${this.$t('blogLinkShareTxt')} ${this.activeBlog.blogInfoDisplay.name}: ${link}`
            })
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      activeBlog: 'entities/blogs/activeBlog'
    }),
    renderList () {
      return this.list.filter(item => {
        if (!item.displayCondition) return true
        return item.displayCondition()
      })
    }
  }
}
</script>

<style lang="scss" module>
.container {
  width: 100%;
  color: $text-darkest;
  padding: 6px 20px 6px 0;
}
.item {
  height: 42px;
  display: flex;
  font-size: 14px;
  align-items: center;
  cursor: pointer;
  &Disabled {
    color: $text-mid;
    cursor: default;
  }
  &:not(.itemDisabled):hover {
    color: $text-colored;
    .icon {
      color: $text-colored;
    }
  }
}
.icon {
  margin: 0 12px;
  color: $text-light;
  font-size: 16px;
}
</style>
